import React from 'react';
import { AlertCircleIcon, CreditCardIcon, LockIcon, ShieldCheckIcon, StarIcon, ZapIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { CHECKOUT_BASIC, CHECKOUT_PREMIUM } from '../data/content';
export function FinalCTA() {
  return <section aria-labelledby="cierre" className="border-b border-line bg-canvas" data-id="element-87" data-mp="844al66a2vea">
      <div className="mx-auto max-w-page px-4 sm:px-6 lg:px-8 py-10 lg:py-12" data-id="element-88" data-mp="m4f1283oe7yx">
        <div className="grid gap-6 lg:grid-cols-2 lg:gap-10" data-id="element-89" data-mp="h5vdy4dciq4z">
          <Reveal data-id="element-90" data-mp="h5c5rfdhzg45">
            <h2 id="cierre" className="font-display text-2xl md:text-4xl font-black uppercase leading-[1.1] text-ink" data-id="element-91" data-mp="h4153ofcmoh9">
              Tu próximo proyecto puede empezar hoy
            </h2>
            <p className="mt-3 text-sm md:text-base leading-relaxed text-ink-muted" data-id="element-92" data-mp="14uwsm9cruxip">
              Podés seguir guardando videos, descargando PDFs y pensando “algún
              día voy a aprender bien Electrónica”. O podés empezar a construir
              una base organizada desde hoy. Porque el conocimiento que nunca
              llevás a la práctica sigue siendo solamente información.
            </p>
            <p className="mt-3 font-display text-lg md:text-xl font-extrabold uppercase leading-snug text-accent" data-id="element-93" data-mp="2m2kukbqf78fe">
              La Electrónica puede convertirse en mucho más que un hobby.
            </p>
            <p className="mt-2 text-sm text-ink-muted" data-id="element-94" data-mp="2v4akfd4nlzb2">
              Una nueva habilidad. Un proyecto. Un servicio. Una herramienta
              profesional. Una forma de enseñar. O el comienzo de tu próximo
              emprendimiento.
            </p>

            <div className="mt-5 flex flex-wrap items-center gap-x-5 gap-y-2 text-xs font-medium text-ink-muted" data-id="element-95" data-mp="34vogfaxecgzg">
              <span className="flex items-center gap-1.5" data-id="element-96" data-mp="3errrx7e51rz2">
                <LockIcon size={14} className="text-ink-subtle" data-id="element-97" data-mp="3etco11g3piz1" />
                Pago seguro
              </span>
              <span className="flex items-center gap-1.5" data-id="element-98" data-mp="3ir0n8gottxwq">
                <ZapIcon size={14} className="text-accent" data-id="element-99" data-mp="1jpej7b8in2rz" />
                Acceso digital inmediato
              </span>
              <span className="flex items-center gap-1.5" data-id="element-100" data-mp="1er3c389lv6dg">
                <ShieldCheckIcon size={14} className="text-success" data-id="element-101" data-mp="1sgx05odadmm4" />
                Garantía 7 días
              </span>
              <span className="flex items-center gap-1.5" data-id="element-102" data-mp="1np597cq7xevg">
                <CreditCardIcon size={14} className="text-volt" data-id="element-103" data-mp="22ekx8kyd767g" />
                Mercado Pago
              </span>
            </div>
          </Reveal>

          <Reveal delay={0.05} className="rounded-2xl border border-line bg-surface p-5 md:p-6" data-id="element-104" data-mp="1xf8dwa6pch9m">
            <span className="inline-flex items-center gap-2 rounded-lg bg-danger-soft px-3 py-1.5 text-xs font-bold uppercase tracking-wide text-danger" data-id="element-105" data-mp="27dxttxf1frn8">
              <AlertCircleIcon size={14} data-id="element-106" data-mp="h29sjdo2zw8u" />
              Oferta activa
            </span>

            <div className="mt-4 rounded-xl border border-line bg-surface-alt p-4" data-id="element-107" data-mp="d0y61h0i7r4v">
              <p className="font-display text-sm font-extrabold uppercase text-ink" data-id="element-108" data-mp="2vpyhnwjswg2">
                Mega Pack Electrónica para Emprender
              </p>
              <p className="mt-0.5 text-xs text-ink-muted" data-id="element-109" data-mp="6ze6g7p3du1u">
                6 Tomos + 6 Bonos
              </p>
              <p className="mt-2 flex items-baseline gap-2" data-id="element-110" data-mp="3uanjcy7h7dig">
                <span className="text-sm text-ink-subtle line-through" data-id="element-111" data-mp="3u92n945ijmih">
                  $51.000
                </span>
                <span className="font-display text-2xl font-black text-ink" data-id="element-112" data-mp="3ffprs7k5is2f">
                  $19.990 ARS
                </span>
              </p>
              <CtaButton href={CHECKOUT_BASIC} external variant="secondary" className="mt-3" data-id="element-113" data-mp="36dgexb1eumlv">
                Quiero el Mega Pack
              </CtaButton>
            </div>

            <div className="mt-3 rounded-xl border-2 border-accent bg-accent-soft p-4" data-id="element-114" data-mp="14jh8p435avg1">
              <p className="flex items-center gap-1.5 font-display text-sm font-extrabold uppercase text-accent" data-id="element-115" data-mp="19ic02uf6hsbr">
                <StarIcon size={13} className="fill-accent" data-id="element-116" data-mp="35l6wg82dzb98" />
                Recomendado — Mega Pack + Kit Emprendedor Pro
              </p>
              <p className="mt-0.5 text-xs text-ink-muted" data-id="element-117" data-mp="2voc281d5bx0r">
                6 Tomos + 6 Bonos + Kit Emprendedor Pro
              </p>
              <p className="mt-2 flex items-baseline gap-2" data-id="element-118" data-mp="2rnifhbbfwo9g">
                <span className="text-sm text-ink-subtle line-through" data-id="element-119" data-mp="2moytxc0rdehm">
                  $69.000
                </span>
                <span className="font-display text-3xl font-black text-accent" data-id="element-120" data-mp="2hwdzq9dxwzdk">
                  $27.990 ARS
                </span>
              </p>
              <CtaButton href={CHECKOUT_PREMIUM} external size="lg" className="mt-3" data-id="element-121" data-mp="2802l3cqvnxfy">
                Quiero el Mega Pack + Kit Pro
              </CtaButton>
            </div>
          </Reveal>
        </div>
      </div>
    </section>;
}